import { FieldsType } from '@flatsy/core/Form/Library/Types'
import { validateHexaColor as validateHexaColorUtils } from '../../Validators'
import { getEmailError, getPhoneError } from '../Errors'

/**
 * @name validateNotEmptyOrUndefined
 * @description check if str is undefined or empty
 * @param str : string
 */
export const validateNotEmptyOrUndefined = (str: string | undefined): string | undefined => {
  if (!str || str === undefined || (typeof str === 'string' && !str.trim())) {
    return 'Ce champ ne peut être vide'
  }
  return undefined
}

/**
 * @name validateNotEmpty
 * @description check if str is undefined
 * @param value
 */
export const validateNotEmpty = (value: unknown): string | undefined => {
  return value ? undefined : 'Ce champ ne peut être vide'
}

/**
 * @name validatePhoneNumber
 * @description check phone number
 * @param value
 */
export const validatePhoneNumber = (value: string | undefined): string | undefined => {
  const error = getPhoneError({
    phoneNumber: value,
  })

  if (typeof error === 'string') {
    return error
  }

  return undefined
}
/**
 * @name validateEmail
 * @description check email format
 * @param value
 */
export const validateEmail = (value: string | undefined): string | undefined => {
  const error = getEmailError({
    email: value,
  })

  if (typeof error === 'string') {
    return 'Ce champ ne peut être vide'
  }

  return undefined
}

/**
 * @name validateAddress
 * @description check address format
 * @param value
 */
export const validateAddress = (value: string | undefined): string | undefined => {
  if (!value || value === undefined) {
    return 'Ce champ ne peut être vide'
  }
  if (typeof value === 'object') {
    if (
      Object.prototype.hasOwnProperty.call(value, 'id') &&
      Object.prototype.hasOwnProperty.call(value, 'description')
    ) {
      const object = value as { id: string; description: string }
      if (
        validateNotEmptyOrUndefined(object.id) ||
        validateNotEmptyOrUndefined(object.description)
      ) {
        return 'Ce champ ne peut être vide'
      }
    }
  }
  return undefined
}

/**
 * @name validateHexaColor
 * @description check hexacolor value
 * @param hexaColor
 */
export const validateHexaColor = (hexaColor: string | undefined): string | undefined => {
  if (hexaColor === undefined) {
    return undefined
  }

  const isNotEmpty = validateNotEmptyOrUndefined(hexaColor.substr(1))

  if (isNotEmpty) {
    return isNotEmpty
  }

  if (!validateHexaColorUtils(hexaColor)) {
    return "La couleur saisie n'est pas au format hexadecimal"
  }

  return undefined
}

/**
 * @name renderValidation
 * @description render validation by field.validation or use a custom validation function
 * @param field : FieldsType
 */
export const renderValidation = (
  field: FieldsType
): undefined | ((str: string | undefined) => string | undefined) => {
  if (field && field.validation) {
    if (field.validation === 'validateNotEmptyOrUndefined') {
      return validateNotEmptyOrUndefined
    }
    if (field.validation === 'validateNotEmpty') {
      return validateNotEmpty
    }
    if (field.validation === 'validateHexaColor') {
      return validateHexaColor
    }
    if (field.validation === 'validatePhoneNumber') {
      return validatePhoneNumber
    }
    if (field.validation === 'validateEmail') {
      return validateEmail
    }
    if (field.validation === 'validateAddress') {
      return validateAddress
    }
    if (field.validation === 'custom' && field.customValidation) {
      const renderCustomValidation = (
        str: string | undefined,
        // eslint-disable-next-line @typescript-eslint/ban-types
        allValues?: Object
      ): string | undefined => {
        if (field && field.customValidation) {
          const val = field.customValidation(str, allValues)
          if (val && typeof val === 'string') {
            return val
          }
        }
        return undefined
      }

      return renderCustomValidation
    }
  }

  return undefined
}
